import { render, staticRenderFns } from "./warnTotalSetting.vue?vue&type=template&id=d7989c14&scoped=true&"
import script from "./warnTotalSetting.vue?vue&type=script&lang=js&"
export * from "./warnTotalSetting.vue?vue&type=script&lang=js&"
import style0 from "./warnTotalSetting.vue?vue&type=style&index=0&id=d7989c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7989c14",
  null
  
)

export default component.exports